<template>
  <div>
    <el-button v-if="!disabled" type="primary" @click="searchData()">{{$t('sensory.report.addPlant')}}</el-button>
    <el-dialog append-to-body :title="$t('sensory.report.FactorySelector')" :visible="showPickupDialog" clearable @close="showPickupDialog = false" width="90%" class="dialog">
      <div class="table">
        <div class="container">
          <div class="handle-box">
            <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="Level1 Category" prop="categoryLevel1Code">
                    <ic-select disabled table="BASE" filterable clearable field="CATEGORY_LEVEL1" @change="queryCondition.categoryLevel2Code=null,queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel1Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Level2 Category" prop="categoryLevel2Code">
                    <ic-select :disabled="categoryLevel2Code" table="BASE" filterable clearable :field="queryCondition.categoryLevel1Code" @change="queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel2Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Level3 Category" prop="categoryLevel3Code">
                    <ic-select :disabled="categoryLevel3Code" :table="queryCondition.categoryLevel1Code" clearable filterable :field="queryCondition.categoryLevel2Code" v-model="queryCondition.categoryLevel3Code"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.plant.plantNo')" prop="plantNo">
                    <el-input v-model.trim="queryCondition.plantNo" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item :label="$t('base.plant.plantName')" prop="plantName">
                    <el-input v-model.trim="queryCondition.plantName" clearable />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCode')" prop="eightBitCode">
                    <el-input v-model.trim="queryCondition.eightBitCode" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCodeName')" prop="eightBitCodeName">
                    <el-input v-model="queryCondition.eightBitCodeName" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.title')" prop="fiveBitCode">
                    <el-input :disabled="fiveBitCode" v-model.trim="queryCondition.fiveBitCode" clearable />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.name')" prop="fiveBitCodeName">
                    <el-input v-model.trim="queryCondition.fiveBitCodeName" clearable />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="center">
                <el-col :span="4">
                  <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
                  <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-row style="margin-bottom:20px">
            <el-button @click="pickUpMaterial" type="primary">{{$t("common.select")}}</el-button>
          </el-row>
          <el-table :data="tableData" ref="dataList" border highlight-current-row class="table" max-height="400" row-key="tmMaterialId">
            <el-table-column type="selection" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel1Name" sortable label="Level1 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel2Name" sortable label="Level2 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel3Name" sortable label="Level3 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plantNo" sortable :label="$t('base.plant.plantNo')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plantName" sortable :label="$t('base.plant.plantName')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eightBitCode" width="90" sortable :label="$t('base.eightBitCode.eightBitCode')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable :label="$t('base.eightBitCode.eightBitCodeName')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="fiveBitCode" sortable :label="$t('base.fiveBitCode.title')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="fiveBitCodeName" sortable :label="$t('base.fiveBitCode.name')"></el-table-column>
          </el-table>
          <div class="pagination">
            <!--===分页组件===-->
            <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import commonFunction from "../../../utils/dataTableUtils"
import { materialService } from "../../../api/base-data/material";
import IcSelect from "@/components/common/icSelect";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import commonFun from "@/utils/commonFun";

export default {
  name: 'pickupPlantMulti',
  components: { IcSelect, SelDc },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    fiveBitCode: {
      type: String,
      default: null
    },
    fiveBitCodeName: {
      type: String,
      default: null
    },
    categoryLevel1Code: {
      type: String,
      default: 10
    },
    categoryLevel2Code: {
      type: String,
      // default: null
    },
    categoryLevel3Code: {
      type: String,
      default: null
    },
    beforeSelect: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      myPlantName: this.plantName,
      tableData: [],
      totalCount: 0,
      queryCondition: {
        categoryLevel1Code: this.categoryLevel1Code,
        categoryLevel2Code: this.categoryLevel2Code,
        categoryLevel3Code: this.categoryLevel3Code,
        plantNo: null,
        plantName: null,
        eightBitCode: null,
        eightBitCodeName: null,
        fiveBitCode: this.fiveBitCode,
        fiveBitCodeName: "",
        pageSize: 15,
        pageNum: 1
      },
      showSelDcDialog: false,
      tempRows: null,
      showPickupDialog: false,
      radioVal: null,
      selectRow: null,
    }
  },
  methods: {
    searchData() {
      this.queryCondition.categoryLevel1Code = this.categoryLevel1Code;
      this.queryCondition.categoryLevel2Code = this.categoryLevel2Code;
      this.queryCondition.categoryLevel3Code = this.categoryLevel3Code;
      this.queryCondition.fiveBitCode = this.fiveBitCode;
      this.queryCondition.fiveBitCodeName = "";
      if (commonFun.isNotEmpty(this.beforeSelect)) {
        if (!this.beforeSelect()) {
          return;
        }
      }
      this.showPickupDialog = true;
      this.queryData();
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      materialService.materialList(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    changeSelect(row) {
      this.selectRow = row;
    },
    pickUpMaterial() {
      let selection = this.$refs.dataList.selection;
      this.$emit("pick-up", selection);
      this.showPickupDialog = false;
      this.$refs.dataList.clearSelection();
    },
    restQueryForm() {
      if (!this.categoryLevel1Code) {
        this.queryCondition.categoryLevel1Code = ''
      }
      if (!this.categoryLevel2Code) {
        this.queryCondition.categoryLevel2Code = ''
      }
      if (!this.categoryLevel3Code) {
        this.queryCondition.categoryLevel3Code = ''
      }
      if (!this.fiveBitCode) {
        this.queryCondition.fiveBitCode = ''
      }
      this.queryCondition.fiveBitCodeName = ''
      this.queryCondition.plantNo = ""
      this.queryCondition.plantName = ""
      this.queryCondition.eightBitCode = ""
      this.queryCondition.eightBitCodeName = ""
      this.queryCondition.pageSize = 15
      this.queryCondition.pageNum = 1
      this.queryData();
    }
  },
  watch: {
    plantName(newVal, oldVal) {
      this.myPlantName = newVal;
    },
    fiveBitCode(val) {
      this.queryCondition.fiveBitCode = val;
    },
    // fiveBitCodeName(val) {
    //   this.queryCondition.fiveBitCodeName = val;
    // },
    categoryLevel1Code(val) {
      this.queryCondition.categoryLevel1Code = val;
    },
    categoryLevel2Code(val) {
      this.queryCondition.categoryLevel2Code = val;
    },
    categoryLevel3Code(val) {
      this.queryCondition.categoryLevel3Code = val;
    }
  },
  extends: commonFunction
}
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
</style>
